<div class="d-flex">
  <!-- Form -->
  <form (ngSubmit)="this.form.submit()" [formGroup]="this.form" class=" flex-grow-1">

    <magieno-select
            [advancedFormControl]="this.form.formElements.year | asAdvancedFormControl"></magieno-select>

    <div class="row">
      <div class="col-12">
        <app-rrsp-personal-tax-form [form]="form"
                                               [incomeTaxPersonalForm]="personalIncomeForm"></app-rrsp-personal-tax-form>
      </div>
    </div>

    <br>
    <br>
    <br>
    <br>

    <!-- Button -->
    <div class="row fixed-bottom">
      <div class="col-12">
        <magieno-button [button]="this.form.getButton('SAVE')" id="saveCalculationButton"></magieno-button>

        <magieno-button [button]="this.form.getButton('EXECUTE')" id="executeCalculationButton"
                    style="margin-left: 12px"></magieno-button>

        <span [class.bg-danger]="calculationStatusEnum === 'ERROR'"
              [class.bg-light]="calculationStatusEnum === 'CREATED'"
              [class.bg-success]="calculationStatusEnum === 'COMPLETED'"
              [class.bg-warning]="calculationStatusEnum === 'IN_PROGRESS'"
              class="badge rounded-pill ms-5"
              style="font-size: 12pt;"

        >{{ getStatusText() }}</span>

        <button (click)="openErrorsSidebar()" [class.bg-danger]="this.numberOfErrors > 0"
                [class.bg-success]="this.numberOfErrors === 0"
                class="btn badge text-white rounded-pill ms-3"
                style="font-size: 12pt;">{{ this.numberOfErrors }}
          erreurs
        </button>

        <span style="margin-left: 15px;">Dernière sauvegarde: <strong>{{ getLastModifiedText() }}</strong></span>

      </div>
    </div>


  </form>

  <app-calculation-form-sidebar></app-calculation-form-sidebar>

</div>
